<template>
  <v-row class="mx-0" :style="{ backgroundColor: bgColor }" :class="[elementClass]">
    <v-col v-if="$vuetify.breakpoint.mdAndUp"
      cols="12"
      sm="12"
      md="6"
      :class="[$vuetify.breakpoint.mdAndUp ? 'profile-img' : 'profile-img-mobile']"
      :style="{backgroundImage: 'url('+image+')'}"
    ></v-col>
    <v-col v-if="$vuetify.breakpoint.mdAndUp" md="6" class="px-md-12 d-flex flex-column justify-center align-start" :class="[colClass]">
      <h1
        class="display-1 text-uppercase font-weight-bold"
        :class="[titleClass]"
        v-if="hasTitle"
        v-html="title"
      ></h1>
      <div v-for="(item, index) in textArray" :key="index">
        <h3
           align="justify"
          class="font-italic font-weight-medium"
          :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'subtitle-1', textClass]"
          v-html="item.title"
        ></h3>
        <p
           align="justify"
          :class="[$vuetify.breakpoint.mdAndUp ? 'headline font-weight-light' : 'subtitle-1 font-weight-regular', textClass]"
          v-html="item.text"
        ></p>
      </div>
    </v-col>
    <v-col v-else xs="12" class="px-md-12 d-flex flex-column justify-center align-start" :class="[colClass]">
      <h1
        class="display-1 text-uppercase font-weight-bold"
        :class="[titleClass]"
        v-if="hasTitle"
        v-html="title"
      ></h1>
      <div v-for="(item, index) in textArray" :key="index">
        <h3
           align="justify"
          class="font-italic font-weight-medium"
          :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'subtitle-1', textClass]"
          v-html="item.title"
        ></h3>
        <p
           align="justify"
          :class="[$vuetify.breakpoint.mdAndUp ? 'headline font-weight-light' : 'subtitle-1 font-weight-regular', textClass]"
          v-html="item.text"
        ></p>
      </div>
    </v-col>
  </v-row>
</template>
<style scoped>
.profile-img {
  background-size: cover;
  min-height: 70vh;
  background-position: center;
}
.profile-img-mobile {
  background-size: contain;
  height: 200px;
  background-position: center;
}
</style>
<script>
export default {
  props: [
    "bgColor",
    "hasTitle",
    "title",
    "textArray",
    "image",
    "textClass",
    "titleClass",
    "hasImage",
    "elementClass",
    "colClass"
  ],
  mounted(){
  },
  data: () => ({ publicPath: process.env.BASE_URL })
};
</script>